var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M.1 25.172C.1 11.324 21.55.097 48.024.097s47.934 11.227 47.934 25.076-21.46 25.076-47.934 25.076S.1 39.02.1 25.172",
    id: "A"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "30.020204%",
    cy: "82.421541%",
    fx: "30.020204%",
    fy: "82.421541%",
    r: "125.506941%",
    gradientTransform: "translate(0.300202,0.824215),scale(0.523135,1.000000),translate(-0.300202,-0.824215)",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aeb2d5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aeb2d5",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484c89",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484c89",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M0 55.862h99.86V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M0 55.862h99.86V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 33.083218 74.903275)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.907 2.759)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "E",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#E)",
    fill: "url(#B)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.1 25.172C.1 11.324 21.55.097 48.024.097s47.934 11.227 47.934 25.076-21.46 25.076-47.934 25.076S.1 39.02.1 25.172"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.93 4.717c25.438 0 46.06 10.393 46.06 23.214S75.37 51.145 49.93 51.145 3.87 40.75 3.87 27.93 24.492 4.717 49.93 4.717",
    fill: "#777bb3",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "G",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#G)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.04 25.053c2.092 0 3.653.384 4.64 1.14.977.748 1.653 2.045 2.006 3.854.33 1.69.204 2.87-.373 3.508-.59.65-1.868.98-3.796.98h-3.343l-1.853-9.483h2.717zm-10.933-11.68a.52.52 0 0 0-.401.188c-.1.12-.14.276-.11.428l4.91 25.13a.52.52 0 0 0 .511.418h10.585c3.327 0 5.803-.898 7.36-2.67 1.565-1.78 2.048-4.27 1.436-7.4a11.77 11.77 0 0 0-1.273-3.519c-.596-1.06-1.384-2.043-2.342-2.92-1.147-1.068-2.445-1.842-3.855-2.297-1.387-.45-3.17-.677-5.296-.677h-4.286l-1.224-6.262a.52.52 0 0 0-.51-.419h-5.505z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.605 34.02h2.914c2.327 0 3.135-.508 3.4-.8.456-.502.542-1.562.25-3.063-.33-1.68-.94-2.873-1.813-3.542-.895-.685-2.35-1.032-4.324-1.032h-2.086l1.65 8.448zm4.998 6.034H22.018a1.04 1.04 0 0 1-1.021-.837l-4.91-25.13a1.03 1.03 0 0 1 .218-.855 1.04 1.04 0 0 1 .803-.376h5.505a1.04 1.04 0 0 1 1.021.837l1.142 5.844h3.857c2.18 0 4.018.237 5.458.703 1.48.478 2.843 1.3 4.05 2.41.997.912 1.82 1.937 2.44 3.044s1.07 2.344 1.33 3.673c.644 3.294.12 5.93-1.555 7.84-1.66 1.89-4.267 2.847-7.75 2.847zm-7.91-15.517h3.348c2.22 0 3.872.416 4.96 1.247s1.82 2.22 2.2 4.165c.364 1.868.198 3.186-.498 3.953s-2.09 1.152-4.182 1.152h-3.77l-2.055-10.517zm7.91 14.483c3.184 0 5.507-.83 6.967-2.493s1.9-3.982 1.317-6.96c-.24-1.227-.645-2.35-1.216-3.365s-1.318-1.947-2.24-2.8c-1.1-1.023-2.32-1.752-3.664-2.186s-3.055-.652-5.135-.652h-4.715L22.61 13.9h-5.505l4.91 25.13h10.585z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.02 20.053a.52.52 0 0 0-.401.188c-.1.12-.14.276-.11.428l2.173 11.12c.207 1.057.156 1.816-.143 2.137-.183.196-.733.525-2.36.525h-3.936l-2.73-13.978a.52.52 0 0 0-.511-.419h-5.46a.52.52 0 0 0-.401.188c-.1.12-.14.276-.11.428l4.91 25.13a.52.52 0 0 0 .511.418h5.46a.52.52 0 0 0 .401-.188c.1-.12.14-.276.11-.428l-1.185-6.065h4.234c3.226 0 5.413-.566 6.687-1.73 1.3-1.187 1.704-3.085 1.204-5.64l-2.285-11.694a.52.52 0 0 0-.511-.419H54.02z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.912 46.734h-5.46a1.04 1.04 0 0 1-1.021-.837l-4.91-25.13a1.03 1.03 0 0 1 .218-.855 1.04 1.04 0 0 1 .803-.376H46a1.04 1.04 0 0 1 1.021.837l2.65 13.56h3.507c1.623 0 1.964-.345 1.978-.36.098-.105.228-.593.014-1.686l-2.173-11.12a1.03 1.03 0 0 1 .218-.855 1.04 1.04 0 0 1 .803-.376h5.548a1.04 1.04 0 0 1 1.021.837l2.285 11.694c.536 2.745.077 4.804-1.363 6.12-1.374 1.255-3.677 1.866-7.04 1.866H50.87l1.065 5.45a1.03 1.03 0 0 1-.218.855c-.198.238-.492.377-.803.377m0-1.034l-1.306-6.68h4.865c3.06 0 5.173-.53 6.335-1.593s1.5-2.783 1.046-5.162L59.567 20.57H54.02l2.173 11.12c.247 1.265.156 2.128-.273 2.588s-1.343.7-2.74.7h-4.365L46 20.57h-5.46l4.91 25.13h5.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.004 25.053c2.092 0 3.653.384 4.64 1.14.977.748 1.653 2.045 2.007 3.854.33 1.69.204 2.87-.374 3.508-.59.65-1.868.98-3.796.98H70.14l-1.853-9.483h2.717zM60.07 13.372a.52.52 0 0 0-.401.188c-.1.12-.14.276-.11.428l4.91 25.13a.52.52 0 0 0 .511.418h10.585c3.327 0 5.803-.898 7.36-2.67 1.565-1.78 2.048-4.27 1.436-7.4-.25-1.275-.677-2.46-1.273-3.52s-1.384-2.043-2.342-2.92c-1.147-1.068-2.445-1.842-3.855-2.297-1.387-.45-3.17-.677-5.296-.677H67.31l-1.223-6.262a.52.52 0 0 0-.511-.419H60.07z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57 34.02h2.914c2.327 0 3.135-.508 3.4-.8.456-.502.542-1.562.25-3.063-.33-1.68-.94-2.873-1.813-3.542-.895-.685-2.35-1.032-4.324-1.032h-2.086l1.65 8.448zm4.998 6.034H64.982a1.04 1.04 0 0 1-1.021-.837l-4.91-25.13a1.03 1.03 0 0 1 .218-.855 1.04 1.04 0 0 1 .803-.376h5.505a1.04 1.04 0 0 1 1.021.837l1.142 5.844h3.857c2.18 0 4.018.237 5.458.703 1.48.478 2.843 1.3 4.05 2.41a12.31 12.31 0 0 1 2.441 3.044c.623 1.108 1.07 2.344 1.33 3.673.644 3.294.12 5.932-1.555 7.84-1.66 1.89-4.267 2.847-7.75 2.847zm-7.91-15.517h3.348c2.22 0 3.872.416 4.96 1.247s1.82 2.22 2.2 4.165c.364 1.868.2 3.186-.498 3.953s-2.09 1.152-4.182 1.152h-3.77l-2.055-10.517zm7.91 14.483c3.184 0 5.507-.83 6.967-2.493s1.9-3.982 1.317-6.96c-.24-1.227-.645-2.35-1.216-3.365s-1.318-1.947-2.24-2.8c-1.1-1.023-2.32-1.752-3.664-2.186s-3.055-.652-5.135-.652H66.88l-1.305-6.68H60.07l4.91 25.13h10.585z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/PHP.bce024947a3b1b7abb8979aa113bd870.svg";
export { ForwardRef as ReactComponent };